import React from 'react';

const SvgKey = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M7 5a7 7 0 106.707 9H18v3h4v-3h2v-4H13.707A7 7 0 007 5zm0 4a3 3 0 110 6 3 3 0 010-6z" />
  </svg>
);

export default SvgKey;
